import React, { useState, useEffect, useMemo, useCallback  } from 'react';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Other_payments = () => {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState('');
  const [amount, setAmount] = useState('');
  const [transactionDate, setTransactionDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [paymentReports, setPaymentReports] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [filteredTotal, setFilteredTotal] = useState(0);
  const [gridApi, setGridApi] = useState(null);

  
useEffect(() => {
    fetchServices();
    fetchPaymentReports();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/get_other_service_mode`);
      setServices(response.data);
    } catch (err) {
      console.error('Error fetching services:', err);
      setError('Failed to load services');
    }
  };


  const onFilterChanged = useCallback(() => {
    if (gridApi) {
      let total = 0;
      gridApi.forEachNodeAfterFilter(node => {
        total += parseFloat(node.data.TXN_AMOUNT || 0);
      });
      setFilteredTotal(total);
    }
  }, [gridApi]);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };


  const fetchPaymentReports = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/get_other_payments_report`);
      setRowData(response.data);
    } catch (err) {
      console.error('Error fetching payment reports:', err);
      setError('Failed to load payment reports');
    }
  };



  // const handleDelete = async (id) => {
  //   const loggedInUser = localStorage.getItem('username');
  //   if (loggedInUser !== 'prabha' && loggedInUser !== 'admin') {
  //     showAlert('You do not have permission to delete this payment.', 'error');
  //     return;
  //   }
  
  //   if (window.confirm("Are you sure you want to delete this payment?")) {
  //     try {
  //       await axios.delete(`${API_BASE_URL}/api/delete_other_payment/${id}?username=${loggedInUser}`);
  //       showAlert('Payment deleted successfully!', 'success');
  //       fetchPaymentReports();
  //     } catch (err) {
  //       console.error(err);
  //       showAlert('Failed to delete payment.', 'error');
  //     }
  //   }
  // };


  const handleDelete = async (id) => {
    const loggedInUser = localStorage.getItem('username');
    // Check if the logged in user is one of the allowed users
    const allowedUsers = ['prabha', 'admin', 'amaravathi'];
    if (!allowedUsers.includes(loggedInUser)) {
      showAlert('You do not have permission to delete this payment.', 'error');
      return;
    }
  
    if (window.confirm("Are you sure you want to delete this payment?")) {
      try {
        await axios.delete(`${API_BASE_URL}/api/delete_other_payment/${id}?username=${loggedInUser}`);
        showAlert('Payment deleted successfully!', 'success');
        fetchPaymentReports();
      } catch (err) {
        console.error(err);
        showAlert('Failed to delete payment.', 'error');
      }
    }
  };
  

  const [columnDefs] = useState([
    {
      headerName: 'S.No', 
      valueGetter: "node.rowIndex + 1",  // This will calculate serial number starting from 1
      flex: 1, 
      sortable: true, 
      filter: true, 
      minWidth: 100 
  },  

   {
    headerName: 'Actions',
    flex: 1, sortable: true, filter: true, minWidth: 100,
    cellRenderer: (params) => (
        <div className="flex space-x-1">
        {/* <button
            onClick={() => handleEdit(params.data)}  // Call handleEdit with the plan data
            className="px-1 py-1 text-red-500 rounded"
        >
            Edit
        </button> */}
        <button
            onClick={() => handleDelete(params.data.id)}
            className="px-3 py-1 text-blue-500 rounded"
        >
            Delete
        </button>
        </div>
    ),
    },
    { headerName: 'Service', field: 'type', flex: 1 },
    { headerName: 'Amount', field: 'TXN_AMOUNT', flex: 1 },
    { headerName: 'Transaction Date', field: 'TXN_DATE', flex: 1 , minWidth: 150},
    { headerName: 'Status', field: 'TXN_STATUS', flex: 1 },
    { headerName: 'Created By', field: 'cby', flex: 1 , },
    { 
      headerName: 'Created At', 
      field: 'cdate', 
      flex: 1, 
      minWidth: 180,
      valueFormatter: (params) => new Date(params.value).toLocaleString()
    },
  ]);
  

    // Calculate Total Amount
    const totalAmount = useMemo(() => {
      return rowData.reduce((sum, row) => sum + parseFloat(row.TXN_AMOUNT || 0), 0);
    }, [rowData]);



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Check if user is logged in
    const loggedInUser = localStorage.getItem('username');
    if (!loggedInUser) {
      showAlert('Please log in before submitting payment details.', 'error');
      setLoading(false);
      return;
    }
    
    const userid = localStorage.getItem('userid');

    try {
      const payload = {
        type: selectedService,
        userid: userid,
        TXN_AMOUNT: amount,
        TXN_DATE: transactionDate,
        amount: amount,
        actual_amount: amount,
        total_amount: amount,
        cby: loggedInUser,
      };

      const response = await axios.post(`${API_BASE_URL}/api/save_google_ads_payment`, payload);

      if (response.status === 201) {
        showAlert('Payment details saved successfully!', 'success');
        setAmount('');
        setTransactionDate('');
        setSelectedService('');
        fetchPaymentReports(); // Refresh the table

      } else {
        setError('Failed to save payment details. Please try again.');
      }
    } catch (err) {
      setError('An error occurred while saving the payment details.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const showAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert({ message: '', type: '' });
    }, 3000);
  };

  return (
    <div className="bg-gray-100 p-4">
      <div className="max-w-xl mx-auto bg-white shadow-md rounded mb-4 mt-8">
        <div className="bg-teal-500 text-white px-5 py-3 rounded-t">
          <h2 className="text-xl font-bold">Other Payments</h2>
        </div>
        <form className="p-6 flex flex-col space-y-3" onSubmit={handleSubmit}>
          <div>
            <label className="block text-gray-700">Service:<span className="text-red-500">*</span></label>
            <select
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
              className="w-full p-2 mt-2 border border-gray-300 rounded"
              required
            >
              <option value="" disabled>Select a service</option>
              {services.map((service) => (
                <option key={service.id} value={service.id}>
                  {service.service}
                </option>
              ))}
            </select>
          </div>

          {/* Render Amount field for all services */}
          {selectedService && (
            <div>
              <label className="block text-gray-700">Amount:<span className="text-red-500">*</span></label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter amount"
                className="w-full p-2 mt-2 border border-gray-300 rounded"
                required
                onWheel={(e) => e.target.blur()} // 👈 Prevent scroll changing value
              />
            </div>
          )}

          <div>
            <label className="block text-gray-700">Transaction Date:<span className="text-red-500">*</span></label>
            <input
              type="date"
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              required
              className="w-full p-2 mt-2 border border-gray-300 rounded cursor-pointer"
              onKeyDown={(e) => e.preventDefault()} // Prevent manual input
              onClick={(e) => e.target.showPicker()} // Open calendar picker
            />
          </div>

          <div className="flex justify-end py-3">
            <button type="submit" className="px-4 py-2 bg-teal-500 text-white rounded" disabled={loading}>
              {loading ? 'Saving...' : 'Save Payment Details'}
            </button>
          </div>
          
        </form>
        
        
      </div>
   {/* AG Grid Report */}
   <div className="max-w-5xl mx-auto bg-white shadow-md rounded mb-6">
        <div className="p-6">
        <h2 className="flex items-center text-teal-700 text-xl font-bold mb-4">
  <span className="pr-3">Other Payment Report</span>
  <span className="flex items-center space-x-3 text-sm">
    <span className="flex items-center bg-blue-50 text-blue-700 px-4 py-4 rounded-full">Total Amount : 
      
      ₹{totalAmount.toFixed(2)}
    </span>
    <span className="flex items-center bg-green-50 text-green-700 px-4 py-4 rounded-full">Filtered Amount :
      
      ₹{filteredTotal.toFixed(2)}
    </span>
  </span>
</h2>
          <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
          <AgGridReact 
  rowData={rowData} 
  columnDefs={columnDefs} 
  defaultColDef={{ sortable: true, filter: true }}
  pagination={true} 
  paginationPageSize={10}
  onGridReady={onGridReady}
  onFilterChanged={onFilterChanged}
  onSortChanged={onFilterChanged} // Also update total when sorting changes
/>
          </div>
        </div>
      </div>


      {alert.message && (
        <div className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg transition-all duration-300 z-50 ${alert.type === 'success' ? 'bg-green-500' : 'bg-red-500'}`}>
          <span>{alert.message}</span>
        </div>
      )}
    </div>
  );
};

export default Other_payments;
